import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';
import theme from '../../../styles/theme';

export const IconTooltip = withStyles({
  tooltip: {
    fontSize: '11px',
  },
})(Tooltip);

export const useStyles = makeStyles(() => ({
  add: {
    width: '36px',
    height: '36px',
    marginTop: '5px',
    padding: '0px !important',
    '& svg': {
      marginBottom: '0px',
    },
  },
  titleBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '9px',
    marginBottom: '25px',
    '& h6': {
      marginLeft: '10px',
      marginRight: '10px',
    },
    '& svg': {
      fill: '#FF6347',
    },
  },
  list: {
    textAlign: 'left',
    paddingLeft: '0px',
    '& li': {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: '13px',
      '& a': {
        color: theme.colors.primary,
      },
    },
    '& .icon': {
      marginRight: '11px',
    },
  },
  popoverBox: {
    backgroundColor: '#1e2247',
    padding: '20px 20px 16px',
    overflowY: 'auto',
    '& .MuiInputBase-input': {
      color: '#fff',
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(255, 255, 255, 0.85)',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: 'rgba(255, 255, 255, 0.12)',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: 'rgba(255, 255, 255, 0.3)',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#7c8aff',
    },
    '& .MuiSelect-icon': {
      color: 'rgba(255, 255, 255, 0.75)',
    },
    '&::-webkit-scrollbar': {
      width: 5,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(255, 255, 255, 0.15)',
      borderRadius: 3,
    },
  },
  sectionLabel: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '0.65rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    marginBottom: 10,
    marginTop: 4,
  },
  dateRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 12,
    '& .MuiFormControl-marginNormal': {
      marginTop: 4,
      marginBottom: 4,
    },
    '& .MuiInputBase-input': {
      color: '#fff',
      fontSize: '0.9rem',
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(255, 255, 255, 0.85)',
      fontSize: '0.85rem',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: 'rgba(255, 255, 255, 0.12)',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: 'rgba(255, 255, 255, 0.3)',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#7c8aff',
    },
    '& .MuiIconButton-root': {
      color: 'rgba(255, 255, 255, 0.75)',
      padding: 6,
    },
  },
  divider: {
    borderColor: 'rgba(255, 255, 255, 0.06)',
    margin: '16px 0',
  },
  typeAssetRow: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginBottom: 12,
    '& .MuiInputBase-input': {
      color: '#fff',
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(255, 255, 255, 0.85)',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: 'rgba(255, 255, 255, 0.12)',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: 'rgba(255, 255, 255, 0.3)',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#7c8aff',
    },
    '& .MuiSelect-icon': {
      color: 'rgba(255, 255, 255, 0.75)',
    },
  },
  addTypeButton: {
    color: 'rgba(255, 255, 255, 0.75)',
    marginLeft: 4,
    padding: 6,
    '&:hover': {
      color: '#7c8aff',
      backgroundColor: 'rgba(124, 138, 255, 0.08)',
    },
  },
  valuesRow: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .MuiInputBase-input': {
      color: '#fff',
      fontSize: '0.9rem',
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(255, 255, 255, 0.85)',
      fontSize: '1.2rem',
    },
    '& .MuiInputAdornment-root .MuiTypography-root': {
      color: 'rgba(255, 255, 255, 0.7)',
      fontSize: '0.85rem',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: 'rgba(255, 255, 255, 0.12)',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: 'rgba(255, 255, 255, 0.3)',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#7c8aff',
    },
  },
  submitButton: {
    marginTop: 16,
    width: '100%',
    padding: '12px 16px',
    borderRadius: 10,
    textTransform: 'none',
    fontSize: '0.9rem',
    fontWeight: 600,
    backgroundColor: '#7c8aff',
    color: '#fff',
    boxShadow: '0 2px 8px rgba(124, 138, 255, 0.3)',
    '&:hover': {
      backgroundColor: '#6b7bff',
      boxShadow: '0 4px 12px rgba(124, 138, 255, 0.4)',
    },
    '&.Mui-disabled': {
      backgroundColor: 'rgba(124, 138, 255, 0.3)',
      color: 'rgba(255, 255, 255, 0.75)',
    },
  },
}));
